// libraries
import Head from 'next/head';

const HeadComponent: React.FC<{ site: any, banner?: any }> = ({ site, banner }) => {
    const fullURL = `https://${site?.site}?verfts=1`;
    const [finalLogo] = `${site?.url_logo}'`.match(/Fotos(.*?)'/g) || [];
    const urlLogo = `https://fotos.sobressai.com.br/${finalLogo}`.replace(
        "'",
        ''
    );
    return (
        <Head>
            <title>{site?.titulo}</title>
            <meta property="og:image" content={site?.url_icon ? site?.url_icon : banner ?  banner.replaceAll('"', "") : urlLogo }></meta>
            <meta property="og:title" content={site?.titulo}></meta>
            <meta property="og:url" content={fullURL}></meta>,
            <meta name="twitter:card" content="summary"></meta>
            <link rel="preconnect" href={"https://"+site?.site}/>
            <link rel="preconnect" href={"https://www."+site?.site}/>
            <meta property="og:description" content={
                    site?.meta_description || site?.titulo ||
                    'A imobiliária mais próxima de você'
                }></meta>
            {!site?.url_icon ? null : (
                <link
                    rel="icon"
                    type="image/x-icon"
                    href={site.url_icon}
                ></link>
            )}
            <meta name="keywords" content={site?.meta_keywords || site?.titulo || 'Imobiliária '+site?.Dados?.empresa}></meta>
            <meta
                name="description"
                content={
                    site?.meta_description || site?.titulo ||
                    'A imobiliária mais próxima de você'
                }
            ></meta>
        </Head>
    );
};

export default HeadComponent;
